import { useTranslations } from 'next-intl'

import { Form, Notice } from '@/shared/ui'

export const RecommenderPhoneNumber = () => {
  const t = useTranslations('signup_bank_account')

  return (
    <>
      <Form.Field name="recommenderPhoneNumber">
        <Form.Label bold optional className="text-black">
          {t('referrer_phone_label')}
        </Form.Label>
        <Form.TextField
          type="tel"
          placeholder={t('referrer_phone_placeholder')}
          fullWidth
        />
        <Form.Message />
      </Form.Field>
      <Notice.Title className="mt-6">{t('notice_title')}</Notice.Title>
      <Notice.List gap={false} className="text-gray-800 *:before:bg-gray-800">
        <Notice.Item>{t('notice_referrer_phone')}</Notice.Item>
      </Notice.List>
    </>
  )
}
